// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPlateHeart = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M3 4v4a4 4 0 003 3.874V20h2v-8.126c1.725-.444 3-2.01 3-3.874V4H9v4a2 2 0 01-1 1.732V4H6v5.732A2 2 0 015 8V4zm17 16v-2a6 6 0 010-12V4a8 8 0 100 16" />,
    <path d="M17.925 9.356c.651 0 1.575 1 1.575 1.779 0-.78.924-1.78 1.575-1.78 1.063 0 1.925.822 1.925 1.834 0 2.167-3.497 4.167-3.497 4.167S16 13.356 16 11.189c0-1.012.862-1.833 1.925-1.833" />
  );
export default SvgIconPlateHeart;
